module.exports = __webpack_public_path__ + "img/9.a343f2dc.png";